import { Box, SvgIcon } from "@mui/material";
import { useMemo } from "react";

import { Paragraph } from "components/Paragraph";
import { ChildrenProps } from "types/props";

type Props = {
  href?: string;
  Icon: typeof SvgIcon;
  text: string;
};

export const ContactInfo = ({ href, Icon, text }: Props) => {
  const WrapperComponent = useMemo(
    () =>
      ({ children }: ChildrenProps) =>
        href ? (
          <a
            href={href}
            style={{
              color: "rgba(0, 0, 0, 0.87)",
              textDecoration: "none",
              display: "flex",
              paddingBottom: 24,
            }}
            target="_blank"
          >
            {children}
          </a>
        ) : (
          <Box display="flex" alignItems="center" paddingBottom={3}>
            {children}
          </Box>
        ),
    [href]
  );

  return (
    <WrapperComponent>
      <Icon color="primary" style={{ marginRight: 15 }} />
      <Paragraph font="xl">{text}</Paragraph>
    </WrapperComponent>
  );
};
